import { render } from "./AllBox.vue?vue&type=template&id=047028fe"
import script from "./AllBox.vue?vue&type=script&lang=js"
export * from "./AllBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__